var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{class:[
    {
      'gl-ml-5': !_vm.contextCommitsEmpty,
      'gl-mt-1': !_vm.commitsEmpty && _vm.contextCommitsEmpty,
    },
  ],attrs:{"variant":_vm.commitsEmpty ? 'confirm' : 'default'},on:{"click":_vm.openModal}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }